import * as React from 'react';
import cx from 'classnames';

import LinkBase from 'components/LinkBase';
import MediaObject from 'components/MediaObject';
import Group from 'entities/Group';
import Organization from 'entities/Organization';
import User from 'entities/User';

import { MouseEventHandler } from 'types/typescript/eventHandlers';

import './AccordionBodyItem.scss';

export type AccordionBodyItemProps = {
  action?: React.ReactElement;
  children: React.ReactElement;
  group?: Group;
  href?: string;
  onClick?: MouseEventHandler;
  organization?: Organization;
  to?: string;
  user?: User;
  avatar?: React.ReactElement;
  subtext?: string;
};

class AccordionBodyItem extends React.Component<AccordionBodyItemProps> {
  renderBody = (children: React.ReactNode) => {
    const { action } = this.props;

    if (action) {
      return (
        <MediaObject center figure="right">
          {children}
          {action}
        </MediaObject>
      );
    }

    return children;
  };

  renderComponent = (children: React.ReactNode) => {
    const { href, to, onClick } = this.props;

    const className = cx('AccordionBodyItem', 'AccordionBodyItem--interactive');

    if (href || to) {
      return (
        <LinkBase href={href} to={to} className={className}>
          {children}
        </LinkBase>
      );
    } else if (onClick) {
      return (
        <button onClick={onClick} className={className}>
          {children}
        </button>
      );
    }

    return <div className={'AccordionBodyItem'}>{children}</div>;
  };

  render() {
    const { children } = this.props;
    return this.renderComponent(this.renderBody(children));
  }
}

export default AccordionBodyItem;
